import { SendEmailStatusEnum } from 'common/src/models';

export const EMAIL_SENT_STATUS_CLASSES: {[key in SendEmailStatusEnum]?: string } = {
  [SendEmailStatusEnum.SENT]: 'icon-email-sent',
  [SendEmailStatusEnum.READ]: 'icon-email-read',
  [SendEmailStatusEnum.NOT_SENT]: 'icon-email-pending',
  [SendEmailStatusEnum.PENDING]: 'icon-email-pending',
  [SendEmailStatusEnum.FAILED]: 'icon-email-failed',
};

export const OVERDUE_NOTICE_STATUS_CLASSES: {[key in SendEmailStatusEnum]?: string } = {
  [SendEmailStatusEnum.SENT]: 'icon-overdue-envelope-sent',
  [SendEmailStatusEnum.READ]: 'icon-overdue-envelope-read',
  [SendEmailStatusEnum.NOT_SENT]: 'icon-overdue-envelope',
  [SendEmailStatusEnum.PENDING]: 'icon-overdue-envelope',
  [SendEmailStatusEnum.FAILED]: 'icon-overdue-envelope-failed',
};

export const EMAIL_SENT_STATUS_CLASSES_OVERDUE_NOTICE: {[key in SendEmailStatusEnum]?: string } = {
  [SendEmailStatusEnum.SENT]: 'blue-400',
  [SendEmailStatusEnum.READ]: 'green-500',
  [SendEmailStatusEnum.NOT_SENT]: 'grey-500',
  [SendEmailStatusEnum.PENDING]: 'grey-500',
  [SendEmailStatusEnum.FAILED]: 'yellow-400',
};

export const EMAIL_SENT_STATUS_CLASSES_CONTROL_CENTER: {[key in SendEmailStatusEnum]?: string } = {
  [SendEmailStatusEnum.SENT]: 'color-blue-400',
  [SendEmailStatusEnum.READ]: 'color-green-500',
  [SendEmailStatusEnum.NOT_SENT]: 'color-main-200',
  [SendEmailStatusEnum.PENDING]: 'color-main-200',
  [SendEmailStatusEnum.FAILED]: 'color-yellow-400',
};
